import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { SiteDocumentsService } from 'app/_services/site-documents.service';
import { SiteService } from 'app/_services/site.service';
import { environment } from 'environments/environment';
import { NotificationService } from 'app/_services/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-site-documents',
  templateUrl: './site-documents.component.html',
})
export class SiteDocumentsComponent implements OnInit {
  public selectedSite: any;
  private selectedSiteId: any;
  public siteDocuments: any = [];

  public isUploadDocumentsModalShown = false;
  public selectedDocumentsArray: any[] = [];
  public isLoading = false;

  constructor(
    private siteService: SiteService,
    private siteDocumentsService: SiteDocumentsService,
    private notificationService: NotificationService,
    activatedRoute: ActivatedRoute,
  ) {
    activatedRoute.params.subscribe((params: Params) => {
      this.selectedSiteId = params.id;
    });
  }

  ngOnInit() {
    this.getSelectedSiteWithDocuments(this.selectedSiteId);
  }

  private getSelectedSiteWithDocuments(id) {
    this.siteService.getSiteById(id).subscribe((data: any) => {
      this.selectedSite = data;
      this.siteDocuments = data.files;
    });
  }

  //
  // Table actions
  //

  public viewDocument(selectedDocument) {
    this.siteDocumentsService.showFile(environment.apiUrl + 'api/ext-file/siteFiles', selectedDocument.fileName);
  }

  public deleteDocument(selectedDocument) {
    Swal.fire({
      title: 'Delete Document?',
      text: 'You will not be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.value) {
        this.siteDocumentsService.deleteSiteDocument(selectedDocument.id).subscribe(() => {
          this.getSelectedSiteWithDocuments(this.selectedSiteId);
          Swal.fire('Deleted!', 'Document has been removed.', 'success');
        });
      }
    });
  }

  //
  // Upload documents
  //

  public showUploadDocumentsModal() {
    this.selectedDocumentsArray = [];
    this.isUploadDocumentsModalShown = true;
  }

  public onFileChange(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      this.selectedDocumentsArray.push(file);
    }
  }

  public onUploadDocumentsFormSubmit() {
    this.isLoading = true;

    const body = {
      siteId: this.selectedSiteId,
      filesArray: this.selectedDocumentsArray,
    };

    this.siteDocumentsService.addSiteDocuments(body).subscribe(
      () => {
        this.isLoading = false;
        this.isUploadDocumentsModalShown = false;

        this.getSelectedSiteWithDocuments(this.selectedSiteId);
        Swal.fire('Success', 'Documents uploaded.', 'success');
      },
      (error: any) => {
        this.isLoading = false;

        if (error.message === 'Infected') {
          this.notificationService.notify('danger', 'Upload Failed', 'File is infected with malware!');
        } else if (error.message === 'EmbeddedScript') {
          this.notificationService.notify('danger', 'Upload Failed', 'File has embedded script - please submit file to Skylark for analysis');
        } else {
          this.notificationService.notify('danger', 'Upload Failed', 'There was an issue uploading the documents');
        }
      }
    );
  }
}
